import { useModalContext } from 'utils/contexts/modal';
import { ConfirmationModal } from './ConfirmationModal';
import { DCB_MODAL } from '../../types';

export const DynamicContentModals = () => {
  const { modalState } = useModalContext<DCB_MODAL>();

  switch (modalState) {
    case DCB_MODAL.Confirmation:
      return <ConfirmationModal />;
    default:
      return null;
  }
};
